'use client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
export default function HoldingNavigation({ links }) {
  const pathname = usePathname();
  return <nav aria-label="Company channels">{links.map(link => {
    const active = pathname === link.href || pathname.endsWith(link.href);
    return <Link key={link.href} href={link.href} aria-current={active ? 'page' : undefined}>{/^(SLZF|SLZ[F]?)$/i.test(link.label) ? "SALZ" : link.label}</Link>;
  })}</nav>;
}
